import { useState } from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { CheckIcon, Square2StackIcon } from "@heroicons/react/24/solid";
import { ModalWrapper } from ".";
import { Button } from "../UI/button";

export default function ConfirmationModal({
  modalOpen,
  title,
  message,
  confirmButtonText,
  Icon = Square2StackIcon,
  toggle,
  onConfirm,
}) {
  
  return (
    <ModalWrapper open={modalOpen} setOpen={toggle}>
      <div className="w-[85vw] lg:w-[35vw]">
        <div className="pb-4 text-center text-black font-bold flex items-center flex-col">
          <Icon className="w-5" />
          {title}
        </div>
        {message && <div className="pb-8 mx-6 text-center text-sm text-gray-800">{message}</div>}

        <div className="mb-4" />

        <div className="mt-3 float-right">
          <Button onClick={onConfirm} color="teal">
            {confirmButtonText}
          </Button>
        </div>
      </div>
    </ModalWrapper>
  );
}
